import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@ingka/button';
import resetIcon from '@ingka/ssr-icon/paths/arrow-pair-squarepath';

import { useAppDispatch } from '@/redux/hooks';
import { reset } from '@/redux/features/code-search/slice';
import {
  reset as resetFilters,
  setCountry,
  setSite,
} from '@/redux/features/code-filters/slice';
import { useGetV1UsersMeQuery } from '@/redux/apis/frontend-api';

export const Reset: FC = () => {
  const { t } = useTranslation();
  const { data: userData } = useGetV1UsersMeQuery();

  const dispatch = useAppDispatch();

  const handleReset = () => {
    dispatch(reset());
    dispatch(resetFilters());
    if (userData) {
      dispatch(setCountry([userData.country.toLocaleLowerCase()]));
      dispatch(setSite([userData.cdsLocation]));
    }
  };

  return (
    <Button
      iconPosition="leading"
      text={t('label.reset')}
      type="secondary"
      ssrIcon={resetIcon}
      size="small"
      onClick={handleReset}
      className="sm:w-[156px]"
    />
  );
};
